.m-item-label {
  line-height: 1.2;
  min-width: 0;
  max-width: 100%;

  &--caption {
    font-size: 0.75em;
    opacity: 0.7;
  }
}
